import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CompanySchema, DataResponse, UpdateCompanyBody } from "schema"
import { z } from "zod"
import { companyQuery } from "../lib/companyQuery"

type Response = DataResponse<z.infer<typeof CompanySchema>>

export function useUpdateCompanyMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpdateCompanyBody> & { logo?: FileList }) => {
      const response = await axios.put<Response>(`/companies`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: companyQuery().queryKey })
    },
  })
}
